<template>
    <div>
        <div v-if="error">
            <div class="error">{{ error }}</div>
        </div>
        <div v-else>
            <h1>נא בחרו את השובר שאתם רוצים לממש</h1>
            <h2>בכל הזמנה ניתן לממש סוג כרטיס אחד בלבד</h2>
            <div class="containersmall">
                <div class="grid">
                    <div v-for="(item, key) in store.companies" :key="key" @click="getCompany(key)">
                        <img :src="'/images/' + item.image" :alt="item.name" :title="item.name" class="pointer" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
.containersmall {
    width: 600px;
    margin: 0 auto;
}

.grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    align-items: stretch;
    justify-items: center;
}

img {
    width: 130px;
}

h1,
h2 {
    text-align: center;
    margin: 0;
}

h1 {
    font-size: 36px;
    font-weight: 700;
}

h2 {
    font-size: 28px;
    font-weight: 600;
    margin-bottom: 40px;
}



@media (max-width: 500px) {

    .containersmall {
        width: 100%;
    }

    .grid {
        grid-template-columns: repeat(2, 1fr);
    }

    h1 {
        font-size: 25px;
    }

    h2 {
        font-size: 20px;
    }

}
</style>
<script>
import { store } from '@/store'
/*import axios from 'axios'
import { log } from '@/utils.js'
import MainLoader from '@/components/loaders/MiniLoader.vue';*/


export default {
    components: {
    },
    created() {
        if (store.id == 0 || !store.api_key) {
            this.error = "התרחשה שגיאה, יש לנסות לבצע את הפעולה מחדש";
        }
    },
    data() {
        return {
            error: '',
            store,
            is_load: true,
        }
    },
    methods: {
        getCompany(key) {
            store.company_key = key;
            this.$router.push({ name: 'set', params: {} });
        },
    }
}
</script>